import { Link } from "react-router-dom";
import { User } from "Domain/User/Entity/User";
import { GridColDef } from "@mui/x-data-grid";
import { Box } from "@mui/material";
import SearchTable from "pages/components/Molecules/SearchTable";
import { USER_SEARCH } from "Application/RequestTypes";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import GppMaybeIcon from "@mui/icons-material/GppMaybe";
import { getUrl, HOME, USER_DETAIL } from "Infrastructure/config/routesConfig";
import CreditorStatusChip from "pages/components/Status/CreditorStatusChip";
import { CreditorStatus } from "Domain/User/Entity/CreditorData";
import UserTypeChip from "pages/components/Status/UserTypeChip";
import Button from "pages/components/FormFields/Button";
import { impersonateUser } from "Application/User/UserService";
import { FilterConfig } from "pages/components/Molecules/SearchFilter";
import { useTranslation } from "react-i18next";

export default function UsersList() {
  const columns: GridColDef<User>[] = [
    {
      field: "email",
      width: 90,
      flex: 1,
      renderCell: (params) => (
        <Link to={getUrl(USER_DETAIL, { id: params.row.publicId })}>
          {params.row.email}
        </Link>
      ),
    },
    {
      field: "name",
      flex: 1,
      valueGetter: (value, row) =>
        row.profile?.firstName + " " + row.profile?.lastName,
    },
    {
      field: "type",
      flex: 1,
      renderCell: (params) => {
        return <UserTypeChip status={params.row.type} />;
      },
    },
    {
      field: "createdAt",
      flex: 1,
      type: "string",
    },
    {
      field: "status",
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell: (params) => {
        const status: CreditorStatus | undefined =
          params.row.creditorData?.status;
        if (!status) {
          return (
            <Box
              sx={{
                display: "grid",
                justifyContent: "center",
                alignContent: "center",
                height: "100%",
              }}
            >
              {params.row.isVerified ? (
                <VerifiedUserIcon color="success" />
              ) : (
                <GppMaybeIcon color="warning" />
              )}
            </Box>
          );
        }
        return <CreditorStatusChip status={status} />;
      },
    },
    {
      field: "action",
      flex: 1,
      renderCell: (params) => {
        function handleUserImpersonate() {
          impersonateUser(params.row.publicId).then((res: any) => {
            if (res && res === "OK") {
              window.location.href = window.location.origin + getUrl(HOME);
            }
          });
        }

        return (
          <Button
            size="small"
            label={"impersonate"}
            onClick={handleUserImpersonate}
          />
        );
      },
    },
  ];

  const { t } = useTranslation();

  return (
    <>
      <SearchTable<User>
        columns={columns}
        filterConfig={getSearchFilters(t)}
        additionalFilters={{
          type: "CREDITOR||DEBTOR",
        }}
        endpoint={USER_SEARCH}
      />
    </>
  );
}

function getSearchFilters(t: Function) {
  return {
    email: "string",
    // createdAt: "date",
    isVerified: "bool",
    type: [
      { label: t("FORM.FIELD.creditor"), value: "CREDITOR" },
      { label: t("FORM.FIELD.debtor"), value: "DEBTOR" },
    ],
  } as FilterConfig;
}
